// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","895":"component---src-templates-page-tsx"}[chunkId] + "-" + {"218":"9de14386f1df93344586","895":"1d53476e1f645310f281"}[chunkId] + ".js";
};